import React, { useState } from 'react';
import upload from '../../../Assets/upload icon.svg'
const ConfirmationModal = ({ title, message, items, onConfirm, onCancel, onFileUpload, viewOnly }) => {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleConfirm = () => {
    if (onFileUpload && file) {
      onConfirm(file);
    } else if (!onFileUpload) {
      onConfirm(); // No file needed
    } else {
      alert('Please upload a file before confirming.');
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full mx-auto">
      <h3 className="text-xl font-bold mb-4 text-center">{title}</h3>
      <p className="text-center">{message}</p>
      {items.length > 0 && (
        <ul className="my-4 list-none text-center"> {/* Added text-center to center list items */}
          {items.map((item, index) => (
            <li key={index} className="border-b py-1">{item}</li>
          ))}
        </ul>
      )}
      {onFileUpload && !viewOnly && (
        <div className="mb-4 w-full">
          <div className="flex items-center justify-center border-dashed border-2 border-gray-300 p-2 rounded w-full">
            {/* Left side image icon */}
            <img
              src={upload} // Replace this with your image path
              alt="Upload Icon"
              className="w-6 h-6 mr-2" // Adjust size of the icon
            />
            <span className="text-gray-500 font-semibold mr-2">Upload</span>
            <input
              type="file"
              onChange={handleFileChange}
              id="fileInput" // Add an ID to the file input
              className="border-none w-full cursor-pointer focus:outline-none opacity-0 absolute" // Hide the default file input
            />
          </div>
          {!file && <p className="text-red-500 text-sm mt-2 text-center">File is required</p>} {/* Centered error message */}
        </div>
      )}
      <div className="mt-4 flex justify-center space-x-2">
        {viewOnly ? (
          <button
            onClick={onCancel}
            className="bg-gray-500 text-white px-3 py-1 rounded hover:bg-gray-600"
          >
            Okay
          </button>
        ) : (
          <>
            <button
              onClick={onCancel}
              className="bg-[#E0E0E0] text-black px-4 py-2 text-sm font-medium rounded w-full hover:bg-[#E0E0E0]"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              disabled={onFileUpload && !file}
              className={`bg-gradient-to-r from-[#1C50A3] to-[#2B68C8] text-white px-4 py-2 font-medium rounded w-full cursor-pointer ' : ''}`}
            >
              Confirm
            </button>
          </>
        )}
      </div>
    </div>
  </div>
  
  );
};

export default ConfirmationModal;
